<template>
  <div class="text-left">
    <b-modal
      id="NotesEdit"
      button-size="sm"
      size="xl"
      centered
      :title="'Notes'"
      v-model="modalShow"
      hide-footer
      no-stacking
      :modal-class="{ 'c-dark-theme': $store.state.darkMode }"
    >
      <!-- {{ selection }} -->
      <b-card class="standardpage reports invoices border-none">
        <div class="availtable datatable">
          <b-card class="w-100pct">
            <b-card-body class="py-0">
              <b-row>
                <b-col cols="12">
                  <b-form-group label="Notes" label-for="notes" label-cols="12">
                    <b-form-textarea
                      id="notes"
                      v-model="item.notes"
                      placeholder="Notes"
                      rows="10"
                      class="smalltextarea"
                    ></b-form-textarea> </b-form-group></b-col
              ></b-row>
              <b-row class="mt-1">
                <b-col>
                  <b-button
                    squared
                    size="sm"
                    variant="outline-primary"
                    class="mr-1"
                    @click="timestamp"
                  >
                    <i class="fa fa-clock-o"></i>
                    Add a timestamp
                  </b-button>
                </b-col>
              </b-row>
            </b-card-body>

            <b-card-footer class="mt-2 ml-1">
              <b-row>
                <b-col class="text-left">
                  <div v-if="busy">
                    <i class="fa fa-spinner fa-spin text-primary"></i>
                  </div>
                  <div v-else>
                    <span v-html="message"></span>
                  </div>
                </b-col>
                <b-col class="text-right" cols="8">
                  <b-button
                    squared
                    size="sm"
                    variant="secondary"
                    class="mr-1"
                    @click="$bvModal.hide('NotesEdit')"
                  >
                    <i class="fa fa-chevron-left pr-1"></i>
                    Back
                  </b-button>
                  <b-button
                    squared
                    size="sm"
                    variant="primary"
                    @click="saveit()"
                  >
                    <i class="fa fa-check"></i>
                    Save It
                  </b-button>
                </b-col>
              </b-row>
            </b-card-footer>
          </b-card>
        </div>
      </b-card>
    </b-modal>
  </div>
</template>
  
  <script>
export default {
  name: "NotesEdit",
  data() {
    return {
      busy: false,
      modalShow: false,
      item: {
        notes: null,
      },
      options: {
        title: "Notes",
        icon: "fa fa-commenting-o",
        debounce: 500,
      },
    };
  },
  watch: {
    modalShow: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
            this.item = this.selection[0];
        }
      },
    },
  },
  methods: {
    async timestamp() {
      this.item.notes +=
        "\n" +
        this.$moment().format("DD/MM/YYYY HH:mm:ss") +
        " " +
        this.user.initials +
        "\n";
    },
    saveit() {
      this.$emit("changed", this.selection);
    },
  },
};
</script>
  
  <style>
</style>